<div class="company-credit-report">
    <PageControl :title="'Company Credit Report'"  :elements_query="sheet_elements">
      <button class="btn btn-bg-green text-xs rounded-small shadow-sm me-2" @click="show_export_modal">
        <i class="fas fa-download me-1"></i> Export Data
      </button>

          
    <!-- Export Modal -->
    <Teleport to="body">
      <div
        class="modal fade"
        :id="'export-modal-' + report_reference"
        tabindex="-1"
        aria-labelledby="exportModalLabel"
        aria-hidden="true"
      >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-header">
            <h6 class="modal-title fw-semibold text-muted">
              Export Company Credit Report Data
            </h6>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label fw-bold">Select Data to Export:</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="export-business-info"
                  v-model="export_options.business_information"
                />
                <label class="form-check-label" for="export-business-info">
                  Business Information
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="export-credit-score"
                  v-model="export_options.credit_score"
                />
                <label class="form-check-label" for="export-credit-score">
                  Credit Score
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="export-principals"
                  v-model="export_options.principals"
                />
                <label class="form-check-label" for="export-principals">
                  Principals Data
                </label>
              </div>
              <div class="form-check" v-if="export_format === 'json'">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="export-raw-json"
                  v-model="export_options.raw_json"
                />
                <label class="form-check-label" for="export-raw-json">
                  Raw JSON Response Data
                </label>
              </div>
            </div>
            
            <div class="mb-3">
              <label class="form-label fw-bold">Export Format:</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exportFormat"
                  id="export-format-csv"
                  value="csv"
                  v-model="export_format"
                />
                <label class="form-check-label" for="export-format-csv">
                  CSV (Separate files for each table)
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exportFormat"
                  id="export-format-excel"
                  value="excel"
                  v-model="export_format"
                />
                <label class="form-check-label" for="export-format-excel">
                  Excel (Multiple sheets in one file)
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exportFormat"
                  id="export-format-json"
                  value="json"
                  v-model="export_format"
                />
                <label class="form-check-label" for="export-format-json">
                  JSON (JavaScript Object Notation)
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-2"
              @click="close_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-bg-green text-xs rounded-small shadow-sm"
              @click="export_data"
              :disabled="!has_selected_tables"
            >
              <i class="fas fa-download me-1"></i>
              Export Data
            </button>
          </div>
        </div>
      </div>
    </div>
    </Teleport>
    </PageControl>
    <PageComponent>
      <SectionSheet>
        <div class="container-fluid py-2 header d-flex align-items-center justify-content-between border-bottom mb-2">
          <div class="d-flex">
            <img class="logo" width="295" height="125" src="@/assets/images/new_black_logo2.svg" alt="Logo" />
          </div>
          <div class="d-flex text-end">
            <div>
              <div class="h4 fw-bold mb-1 ">Commercial Credit Enquiry</div>
              <div class="text-muted text-xs">
                28 Fricker Rd,<br>
                Illovo, Johannesburg,<br>
                2196 South Africa<br>
                Website: <a href="https://www.goodpeopledata.com/" target="_blank"
                  class="text-decoration-none text-muted">www.goodpeopledata.com</a>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow-sm p-2 bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Business Credit Summary</h6>
          </div>
          <div class="card-body">
            <p>
              This report provides a comprehensive assessment of
              <span class="fw-bold text-dark">{{ business_name }}</span>'s credit standing. The business has an overall
              credit score of
              <span class="fw-bold text-dark">{{ overall_score }}</span>, placing it in band
              <span class="fw-bold text-dark">{{ overall_band }}</span>. The company has been in operation since
              {{ registration_date }} and maintains a registration status of "{{
                registration_status
              }}".
            </p>
          </div>
        </div>

        <div class="card shadow-none p-2 border-0 bg-white mb-2">
          <div class="card-body text-center">
            <div class="provider-box">
              Report data provided by
              <a href="https://www.transunion.co.za/" target="_blank" rel="noopener">
                <strong>TransUnion</strong> </a>.
            </div>
          </div>
        </div>

        <div class="card shadow-sm p-2 bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Business Statutory Information</h6>
          </div>
          <div class="card-body">
            <table class="info-table table table-sm">
              <tr>
                <td>Registered Business Name</td>
                <td>{{ business_name }}</td>
              </tr>
              <tr>
                <td>Registration Number</td>
                <td>{{ registration_number }}</td>
              </tr>
              <tr>
                <td>Registration Date</td>
                <td>{{ registration_date }}</td>
              </tr>
              <tr>
                <td>Registration Status</td>
                <td>{{ registration_status }}</td>
              </tr>
              <tr>
                <td>IT Number</td>
                <td>{{ it_number }}</td>
              </tr>
              <tr>
                <td>VAT Number</td>
                <td>{{ vat_number }}</td>
              </tr>
              <tr>
                <td>Tax Number</td>
                <td>{{ tax_number }}</td>
              </tr>
              <tr>
                <td>DUNS Number</td>
                <td>{{ duns_number }}</td>
              </tr>
              <tr>
                <td>Business Type</td>
                <td>{{ business_type }}</td>
              </tr>
              <tr>
                <td>Financial Year End</td>
                <td>{{ financial_year_end }}</td>
              </tr>
              <tr>
                <td>Physical Address</td>
                <td>{{ physical_address }}</td>
              </tr>
              <tr>
                <td>Postal Address</td>
                <td>{{ postal_address }}</td>
              </tr>
              <tr>
                <td>Website</td>
                <td>{{ website }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="report-meta">
          <div>Report Reference: {{ report_reference }}</div>
          <div>Score Date: {{ score_date }}</div>
          <div>Generated: {{ generated_date }}</div>
        </div>
      </SectionSheet>

      <SectionSheet>
        <div class="card shadow-sm p-2 bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Business Credit Rating</h6>
          </div>
          <div class="card-body justify-content-center">
            <div class="row">
              <div class="col-sm-12 d-flex flex-column align-items-center">
                <div class="text-muted">Overall Business Credit Score</div>
                <div class="fw-semibold text-md">Band {{ overall_band }}</div>
              </div>
              <div class="d-flex col-sm-12 justify-content-center">
                <div id="chart-overall-score"></div>
              </div>
              <div class="d-flex col-sm-12 justify-content-center">
                Score Version: {{ cv4bcb01.ScoreVersion || "N/A" }} | Commercial
                Segment: {{ credit_vision_vars.COMSGMNT || "N/A" }} | Principal
                Segment: {{ credit_vision_vars.PRPSGMNT || "N/A" }}
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow-sm p-2 bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Trade Score</h6>
          </div>
          <div class="card-body">
            <div class="col-sm-12 row">
              <div class="col-sm-6 d-flex flex-column align-items-center">
                <div id="chart-liquidation-score"></div>

                <div class="section-subtitle mt-2">Risk Factors for Trade Score</div>
                <ul class="factors-list flex-column" v-if="liquidation_factors && liquidation_factors.length">
                  <li v-for="(factor, i) in liquidation_factors" :key="'liq' + i">{{ format_factor(factor) }}</li>
                </ul>
                <p v-else class="no-factors">No risk factors</p>
              </div>
              <div class="col-sm-6 d-flex flex-column">
                <div class="score-explanation mt-3 w-100">
                  <p class="mb-1"><strong>CV4B Trade Credit Score</strong></p>
                  <p class="text-muted small mb-2">Likelihood that the business will cease business in the next 12
                    months.</p>
                  <p class="note text-muted small fst-italic mb-2">Note: A higher score denotes lower risk.</p>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered">
                      <thead class="table-light">
                        <tr>
                          <th class="text-center text-xs">Risk</th>
                          <th class="text-center text-xs">Score Range</th>
                          <th class="text-center text-xs">Likelihood</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><span class="risk-indicator risk-a"></span> A</td>
                          <td>809 - 999 (C1)</td>
                          <td class="text-center"><span class="badge bg-success">less than 0.5%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-b"></span> B</td>
                          <td>754 - 808 (C2)</td>
                          <td class="text-center"><span class="badge bg-success">0.5% to 1%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-c"></span> C</td>
                          <td>700 - 753 (C3)</td>
                          <td class="text-center"><span class="badge bg-success">1% to 2%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-d"></span> D</td>
                          <td>647 - 699 (C4)</td>
                          <td class="text-center"><span class="badge bg-warning text-dark">2% to 4%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-e"></span> E</td>
                          <td>598 - 646 (C5)</td>
                          <td class="text-center"><span class="badge bg-warning text-dark">4% to 7.5%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-f"></span> F</td>
                          <td>567 - 597 (C6)</td>
                          <td class="text-center"><span class="badge bg-danger">7.5% to 11%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-g"></span> G</td>
                          <td>1 - 566 (D7)</td>
                          <td class="text-center"><span class="badge bg-danger">greater than 11%</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="report-meta">
          <div>Report Reference: {{ report_reference }}</div>
          <div>Score Date: {{ score_date }}</div>
          <div>Generated: {{ generated_date }}</div>
        </div>
      </SectionSheet>

      <SectionSheet>

        <div class="card shadow-sm p-2 bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Principal Score</h6>
          </div>
          <div class="card-body">
            <div class="col-sm-12 row">
              <div class="col-sm-6 d-flex flex-column align-items-center">
                <div id="chart-principal-score"></div>
                <div class="section-subtitle mt-2">Risk Factors for Principal Score</div>
                <ul class="factors-list flex-column" v-if="principal_factors && principal_factors.length">
                  <li v-for="(factor, i) in principal_factors" :key="'prp' + i">{{ format_factor(factor) }}</li>
                </ul>
                <p v-else class="no-factors">No risk factors</p>
              </div>
              <div class="col-sm-6 d-flex flex-column">
                <div class="score-explanation mt-3 w-100">
                  <p class="mb-1"><strong>CV4B SME Principal Score</strong></p>
                  <p class="text-muted small mb-2">Arrears >= 3 payments in the next 12 months on a non-business account
                    linked to principal.</p>
                  <p class="note text-muted small fst-italic mb-2">Note: A higher score denotes lower risk.</p>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered">
                      <thead class="table-light">
                        <tr>
                          <th class="text-center text-xs">Risk</th>
                          <th class="text-center text-xs">Score Range</th>
                          <th class="text-center text-xs">Likelihood</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><span class="risk-indicator risk-a"></span> A</td>
                          <td>649 - 999 (C1)</td>
                          <td class="text-center"><span class="badge bg-success">1% to 15%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-b"></span> B</td>
                          <td>590 - 648 (C2)</td>
                          <td class="text-center"><span class="badge bg-success">16% to 30%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-c"></span> C</td>
                          <td>577 - 589 (C4)</td>
                          <td class="text-center"><span class="badge bg-warning text-dark">31% to 35%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-d"></span> D</td>
                          <td>561 - 577 (C4)</td>
                          <td class="text-center"><span class="badge bg-warning text-dark">36% to 41%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-e"></span> E</td>
                          <td>532 - 560 (C5)</td>
                          <td class="text-center"><span class="badge bg-danger">41% to 45%</span></td>
                        </tr>
                        <tr>
                          <td><span class="risk-indicator risk-f"></span> F</td>
                          <td>1 - 531 (D0)</td>
                          <td class="text-center"><span class="badge bg-danger">greater than 45%</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="report-meta">
          <div>Report Reference: {{ report_reference }}</div>
          <div>Score Date: {{ score_date }}</div>
          <div>Generated: {{ generated_date }}</div>
        </div>
      </SectionSheet>

      <SectionSheet>


        <div class="card shadow-sm p-2 bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Adverse Score</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6 d-flex flex-column align-items-center">
                <div id="chart-judgment-score"></div>
                <div class="section-subtitle mt-2">Risk Factors for Judgement Score</div>
                <ul class="factors-list flex-column" v-if="judgment_factors && judgment_factors.length">
                  <li v-for="(factor, i) in judgment_factors" :key="'jdg' + i">
                    {{ format_factor(factor) }}
                  </li>
                </ul>
                <p v-else class="no-factors">No risk factors</p>

                <div class="score-explanation mt-3 w-100">
                  <p class="mb-1"><strong>Judgement / Default Business</strong></p>
                  <p class="text-muted small mb-2">Likelihood that the business will become severely delinquent on debt
                    in the next 12 months.</p>
                  <p class="note text-muted small fst-italic mb-2">Note: A higher score denotes lower risk.</p>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered">
                      <thead class="table-light">
                        <tr>
                          <th class="text-center text-xs">Score Range</th>
                          <th class="text-center text-xs">Likelihood</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-xs">771 - 999</td>
                          <td class="text-center"><span class="badge bg-success">less than 0.8%</span></td>
                        </tr>
                        <tr>
                          <td class="text-xs">702 - 770</td>
                          <td class="text-center"><span class="badge bg-warning text-dark">0.8% to 7%</span></td>
                        </tr>
                        <tr>
                          <td class="text-xs">1 - 701</td>
                          <td class="text-center"><span class="badge bg-danger">greater than 7%</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 d-flex flex-column align-items-center">
                <div id="chart-delinquency-score"></div>
                <div class="section-subtitle mt-2">Risk Factors for Delinquency Score</div>
                <ul class="factors-list flex-column" v-if="delinquency_factors && delinquency_factors.length">
                  <li v-for="(factor, i) in delinquency_factors" :key="'dlq' + i">
                    {{ format_factor(factor) }}
                  </li>
                </ul>
                <p v-else class="no-factors">No risk factors</p>

                <div class="score-explanation mt-3 w-100">
                  <p class="mb-1"><strong>Delinquency Business Score</strong></p>
                  <p class="text-muted small mb-2">Likelihood that the business will honour its payments to creditors
                    over the next 12 months.</p>
                  <p class="note text-muted small fst-italic mb-2">Note: A higher score denotes lower risk.</p>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered">
                      <thead class="table-light">
                        <tr>
                          <th class="text-center text-xs">Score Range</th>
                          <th class="text-center text-xs">Likelihood</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>776 - 999</td>
                          <td class="text-center"><span class="badge bg-success">less than 11.8%</span></td>
                        </tr>
                        <tr>
                          <td>758 - 775</td>
                          <td class="text-center"><span class="badge bg-warning text-dark">11.8% to 19.6%</span></td>
                        </tr>
                        <tr>
                          <td>1 - 757</td>
                          <td class="text-center"><span class="badge bg-danger">greater than 19.6%</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="report-meta">
          <div>Report Reference: {{ report_reference }}</div>
          <div>Score Date: {{ score_date }}</div>
          <div>Generated: {{ generated_date }}</div>
        </div>
      </SectionSheet>

      <SectionSheet>
          <div class="card shadow-sm p-2 bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Auditors</h6>
          </div>
          <div class="card-body">
            <div class="auditor-info p-3 mb-2 border rounded bg-light">
              <p
                class="mb-0"
                :class="auditors !== 'No auditor information on record.' 
                  ? 'text-dark fw-semibold' 
                  : 'text-muted fst-italic'"
              >
                {{ auditors }}
              </p>
            </div>
            <div v-if="auditor_addresses && auditor_addresses.some(a => a.BusinessAddress)">
              <h6 class="text-uppercase text-muted fw-bold small mt-3 mb-2">Auditor Addresses</h6>
              <div v-for="(address, index) in auditor_addresses" :key="'auditor-address-' + index">
                <p v-if="address.BusinessAddress" class="mb-1">
                  {{ address.BusinessAddress }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow-sm p-2 bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Principals Summary</h6>
          </div>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-12">
                <table class="info-table table table-bordered table-principal table-sm">
                  <tr>
                    <td class="fw-medium">Number of Active Principals</td>
                    <td>{{ number_of_active_principals }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <h6 class="text-uppercase text-muted fw-bold small mt-3 mb-2">Current Principals</h6>
            <div class="table-responsive">
              <table class="table table-sm table-bordered table-principal">
                <thead class="table-light">
                  <tr>
                    <th class="text-xs">Name</th>
                    <th class="text-xs">Position</th>
                    <th class="text-xs">ID Number</th>
                    <th class="text-xs">Date Started</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in principal_table_rows" :key="'principal-row-' + index">
                    <td class="text-xs">{{ row.name }}</td>
                    <td class="text-xs">{{ row.position }}</td>
                    <td class="text-xs">{{ row.id_number }}</td>
                    <td class="text-xs">{{ row.date_started }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

       <div class="report-meta">
          <div>Report Reference: {{ report_reference }}</div>
          <div>Score Date: {{ score_date }}</div>
          <div>Generated: {{ generated_date }}</div>
        </div>
      </SectionSheet>

           <!-- Principal History Pages -->
      <template v-for="(page, page_index) in principal_history_pages" :key="'principal-history-page-' + page_index">
        <SectionSheet>
          <div class="card shadow-sm p-2 bg-white mb-2">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                Principal History
                <span v-if="page.total_pages > 1" class="text-muted small">
                  (Page {{ page.page_number }} of {{ page.total_pages }})
                </span>
              </h6>
              <div v-if="page.total_pages > 1" class="text-muted small">
                Showing {{ page.start_index }} - {{ page.end_index }} of {{ page.total_count }} records
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-sm table-bordered table-principal">
                  <thead class="table-light">
                    <tr>
                      <th class="text-xs">Name</th>
                      <th class="text-xs">Position</th>
                      <th class="text-xs">ID Number</th>
                      <th class="text-xs">Date Started</th>
                      <th class="text-xs">Date Resigned</th>
                      <th class="text-xs">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in page.rows" :key="'principal-history-page-' + page_index + '-row-' + index">
                      <td class="text-xs">{{ row.name }}</td>
                      <td class="text-xs">{{ row.position }}</td>
                      <td class="text-xs">{{ row.id_number }}</td>
                      <td class="text-xs">{{ row.date_started }}</td>
                      <td class="text-xs">{{ row.date_resigned || '-' }}</td>
                      <td>
                        <span :class="['badge', 'text-xs', row.status === 'Active' ? 'bg-success' : 'bg-secondary']">
                          {{ row.status }}
                        </span>
                      </td>
                    </tr>
                    <tr v-if="!page.rows || page.rows.length === 0">
                      <td colspan="6" class="text-center text-muted fst-italic">No principal history available</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="report-meta">
            <div>Report Reference: {{ report_reference }}</div>
            <div>Score Date: {{ score_date }}</div>
            <div>Generated: {{ generated_date }}</div>
          </div>
        </SectionSheet>
      </template>

      <template v-for="(chunk, chunk_index) in Math.ceil(principals.length / 2)" :key="'principal-page-' + chunk_index">
        <SectionSheet>
          <template v-for="(p, i) in principals.slice(
            chunk_index * 2,
            chunk_index * 2 + 2
          )" :key="'principal-' + (chunk_index * 2 + i)">
            <div class="card border shadow-sm rounded mb-2">
              <!-- Principal Card Header with Avatar -->
              <div class="card-header bg-white border-bottom position-relative py-3">
                <div class="d-flex align-items-center">
                  <div class="principal-avatar me-3">
                    <div class="avatar-circle">
                      <span>{{
                        (p.Forename1 ? p.Forename1[0] : "") +
                        (p.Surname ? p.Surname[0] : "")
                      }}</span>
                    </div>
                  </div>
                  <div>
                    <h5 class="mb-0 fw-bold" :id="'principal-' + (chunk_index * 2 + i)">
                      {{
                        [p.Forename1, p.Forename2, p.Forename3, p.Surname]
                          .filter(Boolean)
                          .join(" ")
                      }}
                    </h5>
                    <div class="text-muted">{{ p.Position }}</div>
                  </div>
                </div>
              </div>

              <!-- Principal Card Body -->
              <div class="card-body pt-1">
                <!-- Personal Information Section -->
                <div class="mb-1">
                  <h6 class="text-uppercase text-muted fw-bold small border-bottom pb-2 mb-3">
                    Personal Information
                  </h6>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="info-item mb-2">
                        <div class="label-modern">ID Number</div>
                        <div class="value-modern fw-medium">{{ p.IDNumber }}</div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="info-item mb-2">
                        <div class="label-modern">Date of Birth</div>
                        <div class="value-modern">{{ formatDate(p.DateOfBirth) }}</div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="info-item mb-2">
                        <div class="label-modern">Date Started</div>
                        <div class="value-modern">{{ formatDate(p.DateStarted) }}</div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="info-item mb-2">
                        <div class="label-modern">Info Date</div>
                        <div class="value-modern">{{ formatDate(p.InfoDate) }}</div>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="p.Comment">
                      <div class="info-item mb-2">
                        <div class="label-modern">Comment</div>
                        <div class="value-modern">{{ p.Comment }}</div>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="p.DebtCouncilDate">
                      <div class="info-item mb-2">
                        <div class="label-modern">Debt Council Date</div>
                        <div class="value-modern">{{ formatDate(p.DebtCouncilDate) }}</div>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="p.DebtCouncilDesc">
                      <div class="info-item mb-2">
                        <div class="label-modern">Debt Council Description</div>
                        <div class="value-modern">{{ p.DebtCouncilDesc }}</div>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="p.EmpiricaScore">
                      <div class="info-item mb-2">
                        <div class="label-modern">Empirica Score</div>
                        <div class="value-modern">{{ p.EmpiricaScore }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Compliance Status -->
                <div>
                  <h6 class="text-uppercase text-muted fw-bold small border-bottom">
                    Compliance Status
                  </h6>
                  <div class="row g-1">
                    <div class="col-md-6">
                      <div class="compliance-item">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="label-modern">Civil Court Record</div>
                          <div class="status-badge" :class="{
                            'status-good': p.CivilCourtRecord === 'N',
                            'status-bad': p.CivilCourtRecord === 'Y',
                          }">
                            <i class="fas" :class="{
                              'fa-check': p.CivilCourtRecord === 'N',
                              'fa-times': p.CivilCourtRecord === 'Y',
                            }"></i>
                            {{ p.CivilCourtRecord === 'N' ? 'No' : 'Yes' }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="compliance-item">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="label-modern">Default Data</div>
                          <div class="status-badge" :class="{
                            'status-good': p.DefaultData === 'N',
                            'status-bad': p.DefaultData === 'Y',
                          }">
                            <i class="fas" :class="{
                              'fa-check': p.DefaultData === 'N',
                              'fa-times': p.DefaultData === 'Y',
                            }"></i>
                            {{ p.DefaultData === 'N' ? 'No' : 'Yes' }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="compliance-item">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="label-modern">Notices/Notarial Bonds</div>
                          <div class="status-badge" :class="{
                            'status-good': p.NoticesOrNotarialBonds === 'N',
                            'status-bad': p.NoticesOrNotarialBonds === 'Y',
                          }">
                            <i class="fas" :class="{
                              'fa-check': p.NoticesOrNotarialBonds === 'N',
                              'fa-times': p.NoticesOrNotarialBonds === 'Y',
                            }"></i>
                            {{ p.NoticesOrNotarialBonds === 'N' ? 'No' : 'Yes' }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="compliance-item">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="label-modern">Confirmed By Registrar</div>
                          <div class="status-badge" :class="{
                            'status-good': p.ConfirmedByRegistrar === 'Y',
                            'status-bad': p.ConfirmedByRegistrar === 'N',
                          }">
                            <i class="fas" :class="{
                              'fa-check': p.ConfirmedByRegistrar === 'Y',
                              'fa-times': p.ConfirmedByRegistrar === 'N',
                            }"></i>
                            {{ p.ConfirmedByRegistrar === 'Y' ? 'Yes' : 'No' }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="compliance-item">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="label-modern">Deeds</div>
                          <div class="status-badge status-neutral">
                            {{ p.Deeds }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="compliance-item">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="label-modern">Asset Notarial Bond</div>
                          <div class="status-badge" :class="{
                            'status-good': p.AssetNotarialBond === 'N',
                            'status-bad': p.AssetNotarialBond === 'Y',
                          }">
                            <i class="fas" :class="{
                              'fa-check': p.AssetNotarialBond === 'N',
                              'fa-times': p.AssetNotarialBond === 'Y',
                            }"></i>
                            {{ p.AssetNotarialBond === 'N' ? 'No' : 'Yes' }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="i === principals.slice(chunk_index * 2, chunk_index * 2 + 2).length - 1">
              <div class="report-meta report-meta-margin-top-20">
                <div>Report Reference: {{ report_reference }}</div>
                <div>Score Date: {{ score_date }}</div>
                <div>Generated: {{ generated_date }}</div>
              </div>
            </template>
          </template>
        </SectionSheet>
      </template>

      <SectionSheet>

        <div class="card shadow-sm p-2 bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Disclaimer & Information</h6>
          </div>
          <div class="card-body">
            <p class="text-xs mb-2">
                This report and its contents (collectively the 'report') contains information from public records which TransUnion does not control and which have 
                not been verified unless stated otherwise. TransUnion makes no representations and gives no warranties, undertakings and/or guarantees of 
                whatever nature in relation to the accuracy or correctness of the report, whether express, implied in law, or residual in respect of the report. Use of 
                the reports requires the customer to use its own skill and judgement. TransUnion shall not be liable for any decisions or actions taken by the 
                customer in reliance on the reports. Save as aforesaid, the report and the use thereof are subject to TransUnion's standard subscription agreement, 
                a copy of which is available on request.
              </p>
              <p class="text-xs mb-2">
                The 'Possible Matches' module will list possible judgement information that matches the business name provided by the customer. This information 
                is extracted from a database of judgement information that could not be definitively matched automatically. TransUnion makes no representations 
                and gives no warranties and/or guarantees of whatever nature, whether express, implied in law, or residual in respect of any possible matches 
                furnished to the customer.
              </p>
              <p class="text-xs mb-0">
                Use of possible match data requires customers to use their own skill and judgement and customers may not inform credit applicants that decisions 
                derived from the possible matches module resulted in their credit application being declined.
              </p>
            </div>
            <div class="provider-box my-3 text-center">
              Report created on behalf of
              <a href="https://www.transunion.co.za/" target="_blank" rel="noopener">
                <strong>TransUnion</strong>
              </a>
              by 
              <a href="https://www.goodpeopledata.com/" target="_blank" rel="noopener">
                <strong>THE GOOD PEOPLE DATA COMPANY (PTY) LTD.</strong>
              </a>
              <br> 
              The data provided has not been modified or altered in any way.
            </div>
        </div>

        <div class="report-meta">
          <div>Report Reference: {{ report_reference }}</div>
          <div>Score Date: {{ score_date }}</div>
          <div>Generated: {{ generated_date }}</div>
        </div>
      </SectionSheet>
    </PageComponent>
  </div>
